import months from './months';

export const accountIdsForIgnoringMonth = ['10152644786878452'];

export const conformCustomCampaign = (campaign) => {
  const { start_time: startTime } = campaign;
  const startDate = new Date(startTime);
  const calYear = startDate.getFullYear();
  const { shortName } = months[startDate.getMonth()];
  return {
    ...campaign,
    name: `${calYear}_${shortName}_${campaign.name}`
  };
};



// WEBPACK FOOTER //
// ./src/utils/campaignData.js